export class RegulationColumnModel {
  id: boolean;
  geography: boolean;
  country: boolean;
  regulator: boolean;
  pubType: boolean;
  title: boolean;
  publishDate: boolean;
  division: boolean;
  updatedBy: boolean;
  isManual:boolean;
  finregeTopics:boolean;
  orgTopics:boolean;

  constructor() {
    this.id =  true;
    this.geography =  true;
    this.country =  true;
    this.regulator =  true;
    this.pubType =  true;
    this.title =  true;
    this.publishDate =  true;
    this.division =  true;
    this.updatedBy =  true;
    this.isManual=true;
    this.finregeTopics=true;
    this.orgTopics=true;
  }
}
